/**
 * ButtonThemed
 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  navigationButtons: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    rowGap: 16,
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      rowGap: 0,
      columnGap: 16,
    },
  },
  rounded: {
    borderRadius: 8,
  },
}));

/**
 * ButtonThemed
 *
 * @param title {string} : string
 * @returns {JSX.Element}
 */
function ButtonThemed({
  title,
  onClick,
  loading,
  selected,
  rounded,
  className,
}) {
  const classes = useStyles();

  return (
    <button
      className={clsx('ga-button-default', className, {
        'ga-button-ecommerce-next': selected,
        'ga-button-ecommerce-back': !selected,
        loading,
        [classes.rounded]: rounded,
      })}
      type="button"
      onClick={onClick}
    >
      {title}
    </button>
  );
}

ButtonThemed.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  loading: PropTypes.bool,
  rounded: PropTypes.bool,
  className: PropTypes.string,
};
ButtonThemed.defaultProps = {
  selected: true,
  loading: false,
  rounded: false,
  className: '',
};
export default ButtonThemed;
